class VariantLevelCopy extends HTMLElement {
    constructor () {
      super()

      this.containerEls = this.querySelectorAll('.variant-copy')
      this.initialiseVariantLevelCopy()

    }
  
    initialiseVariantLevelCopy () {

        if (this.containerEls.length < 1) return;

        const change = this.handleChange
        const items = this.containerEls
        
        // watch for url changes
        let previousUrl = ''
        const observer = new MutationObserver(function(mutations) {
        if (window.location.href !== previousUrl) {
            previousUrl = window.location.href
            const url = window.location.href
            const searchParams = new URLSearchParams(new URL(url).search)
            const variantParam = searchParams.get("variant")

            change(variantParam, items)

            }
        });

        const config = {subtree: true, childList: true}

        observer.observe(document, config)

    }
  
    handleChange (variantId, items) {
        items.forEach(el => {
            const id = el.getAttribute('data-id');
            el.classList.remove('variant-copy--show');
            if (variantId === id) {
                el.classList.add('variant-copy--show')
            }
        })
    }
  }
  
  customElements.define('variant-copy', VariantLevelCopy)